<template>
  <div class="content" id="overviewPage">
    <div class="container-fluid">
      <div class="row">
        <div class="offset-9 col-md-3 text-right">
          <date-range-picker
            class="form-group vgt-date-range"
            :placeholder="$t('common.field.start')"
            :startDate="datePicker.defaultStartDate"
            :endDate="datePicker.defaultEndDate"
            @update="getStats()"
            :locale-data="datePicker.locale"
            v-model="dateRange"
            :opens="'left'"
            @change="getStats()"
          >
          </date-range-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-md-6 counter-widget" v-if="generalStats">
          <router-link to="/app/user">
            <stats-card v-if="generalStats.user">
              <div slot="header" class="icon-warning">
                <i class="fa fa-user text-primary"></i>
              </div>
              <div slot="content">
                <p class="card-category">{{ $t("common.labels.users") }}</p>
                <h4 class="card-title">{{ generalStats.user.totalCount }}</h4>
              </div>
              <div slot="footer" @click.prevent="getStats()">
                <i class="fa fa-refresh"></i>
                {{ $t("common.buttons.refresh") }}
              </div>
            </stats-card>
          </router-link>
        </div>
        <div class="col-xl-3 col-md-6 counter-widget">
          <router-link to="/app/company_goodie">
            <stats-card v-if="generalStats.company_goodie">
              <div slot="header" class="icon-success">
                <i class="nc-icon nc-light-3 text-success"></i>
              </div>
              <div slot="content">
                <p class="card-category">
                  {{ $t("common.labels.goodiesWon") }}
                </p>
                <h4 class="card-title">
                  {{ generalStats.company_goodie.totalCount }}
                </h4>
              </div>
              <div slot="footer" @click="getStats()">
                <i class="fa fa-refresh"></i>
                {{ $t("common.buttons.refresh") }}
              </div>
            </stats-card>
          </router-link>
        </div>
        <div class="col-xl-3 col-md-6 counter-widget">
          <router-link to="/app/history">
            <stats-card v-if="generalStats.history">
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-vector text-danger"></i>
              </div>
              <div slot="content">
                <p class="card-category">
                  {{ $t("common.labels.successfulScans") }}
                </p>
                <h4 class="card-title">
                  {{ generalStats.history.totalCount }}
                </h4>
              </div>
              <div slot="footer" @click.prevent="getStats()">
                <i class="fa fa-refresh"></i>
                {{ $t("common.buttons.refresh") }}
              </div>
            </stats-card>
          </router-link>
        </div>
        <div class="col-xl-3 col-md-6 counter-widget">
          <router-link to="/app/scan_verification_request">
            <stats-card v-if="generalStats.scan_verification_request">
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-vector text-danger"></i>
              </div>
              <div slot="content">
                <p class="card-category">Demandes de vérifications</p>
                <h4 class="card-title">
                  {{ generalStats.scan_verification_request.totalCount }}
                </h4>
              </div>
              <div slot="footer" @click.prevent="getStats()">
                <i class="fa fa-refresh"></i>
                {{ $t("common.buttons.refresh") }}
              </div>
            </stats-card>
          </router-link>
        </div>
        <!-- <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-favourite-28 text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Followers</p>
              <h4 class="card-title">+45</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated now
            </div>
          </stats-card>
        </div>-->
      </div>
      <div class="row">
        <div class="col-md-12 widget">
          <chart-card
            v-if="false"
            :chart-data="lineChart.data"
            :chart-options="lineChart.options"
            :graphNeedsRefresh="graphNeedsRefresh"
            :responsive-options="lineChart.responsiveOptions"
          >
            <template slot="header">
              <h4 class="card-title">{{ $t("common.labels.usersPerDay") }}</h4>
            </template>
            <template slot="footer">
              <hr />
              <div class="stats pointer" @click="getStats()">
                <i class="fa fa-refresh"></i>
                {{ $t("common.buttons.refresh") }}
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-md-6 widget">
          <card>
            <template slot="header">
              <h4 class="card-title">Activité récente</h4>
            </template>
            <AjaxTable
              :columns="['User.username', 'barcode1', 'message', 'createdOn']"
              :entity="scan_log"
              :mode="'remote'"
              :url="'/scan-log'"
              :tableNeedsRefresh.sync="tableNeedsRefresh"
              :options="{
                pagination: false,
                noHeaders: true,
                filterInitiallyOn: false,
                saveSearchDatas: false,
                noActions: true,
                actions: {},
                customActions: false,
              }"
            />
          </card>
        </div>

        <div class="col-md-6 widget">
          <card>
            <l-table
              class="table-hover table-striped"
              :columns="statsTable.columns"
              :data="statsTable.data"
            ></l-table>
            <template slot="header">
              <h4 class="card-title">{{ $t("common.labels.statistics") }}</h4>
            </template>
            <template slot="footer">
              <div class="stats pointer" @click="getStats()">
                <i class="fa fa-refresh"></i>
                {{ $t("common.buttons.refresh") }}
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import ChartCard from "@/components/UIComponents/Cards/ChartCard.vue";
import StatsCard from "@/components/UIComponents/Cards/StatsCard.vue";
import Card from "@/components/UIComponents/Cards/Card.vue";
import LTable from "@/components/UIComponents/Table.vue";
import Checkbox from "@/components/UIComponents/Inputs/Checkbox.vue";

export default {
  components: {
    Checkbox,
    Card,
    LTable,
    ChartCard,
    StatsCard,
    DateRangePicker,
  },
  data() {
    return {
      tableNeedsRefresh: false,
      generalStats: [],
      graphNeedsRefresh: false,
      userType: "INSTALLATOR",
      dateRange: {
        startDate: moment().subtract(1, "year").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      datePicker: {
        defaultStartDate: moment().subtract(1, "year").format("YYYY-MM-DD"),
        defaultEndDate: moment().format("YYYY-MM-DD"),
        locale: {
          direction: "ltr", // direction of text
          format: "DD-MM-YYYY", // fomart of the dates displayed
          separator: " - ", // separator between the two ranges
          applyLabel: "Appliquer",
          cancelLabel: "Annuler",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: moment.weekdaysMin(), // array of days - see moment documenations for details
          monthNames: moment.monthsShort(), // array of month names - see moment documenations for details
          firstDay: 1, // ISO first day of week - see moment documenations for details
        },
      },
      // editTooltip: 'Edit Task',
      // deleteTooltip: 'Remove',
      // pieChart: {
      //   data: {
      //     labels: ['40%', '20%', '40%'],
      //     series: [40, 20, 40]
      //   }
      // },
      lineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          low: 0,
          high: 500,
          showArea: false,
          height: "245px",
          axisX: {
            showGrid: false,
          },
          lineSmooth: true,
          showLine: true,
          showPoint: true,
          fullWidth: true,
          chartPadding: {
            right: 50,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              axisX: {
                labelInterpolationFnc(value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      statsTable: {
        columns: ["item", "count"],
        data: [],
      },
    };
  },
  mounted() {
    this.getStats();
  },
  methods: {
    getStats() {
      this.$http
        .get("/stats", {
          params: {
            userType: this.userType,
            dateRange: this.dateRange,
          },
        })
        .then((res) => {
          this.generalStats = res.data.body;

          // For Chart
          const days = [];
          const daysCount = [];
          let max = 0;
          this.generalStats.user.perMonth.forEach((user) => {
            days.push(`${user.day}/${user.month}`);
            daysCount.push(user.count);
            if (max < user.count) {
              max = user.count;
            }
          });
          this.lineChart.data.labels = [...days];
          this.lineChart.data.series = [[...daysCount]];
          this.lineChart.options.high = max;

          // For Table
          const tableData = [];
          Object.keys(this.generalStats).forEach((item) => {
            tableData.push({
              item: this.$t(`stats.table.${item}`),
              count: this.generalStats[item].totalCount,
            });
          });
          this.statsTable.data = tableData;

          this.$forceUpdate();
          this.graphNeedsRefresh = true;
        })
        .catch((err) => console.warn(err));
    },

    titleCase(str) {
      str = str.toLowerCase().split(" ");
      for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(" ");
    },

    onDateFilter() {},
  },
};
</script>
<style>
.daterangepicker.dropdown-menu {
  visibility: visible;
  opacity: 1;
}
</style>
